import { z } from 'zod'

/** Who wrote a review: a person in the couple, or the event's planning company. */
export const REVIEWER_ROLES = ['couple', 'planner'] as const

export const reviewerRoleSchema = z.enum(REVIEWER_ROLES)

export type ReviewerRole = z.infer<typeof reviewerRoleSchema>
